// ============================================================================
// MonEquipeMemberRedirect — route historique (L10, F-167) — /mon-equipe/:email
// ============================================================================
// Portage TEL QUEL du PoC mon-equipe/[email]/page.tsx (14 lignes, 1 export
// default = redirect) : la fiche employe n'a jamais vecu sous /mon-equipe — sa
// logique est /profile/{email} onglet Gestion (les 28 actions du PoC sont §B.5 =
// L09/ManagementTab, hors lot). Cette route ne garde donc AUCUN ecran : elle
// preserve les deep-links legacy.
//
// Aucune garde ici : la cible /profile/:email porte les siennes (M-801). Rediriger
// n'expose rien — c'est /profile qui decide ce que le viewer a le droit de voir.
// `replace` : le deep-link legacy ne doit pas polluer l'historique du navigateur.

import { Navigate, useParams } from 'react-router-dom';

export default function MonEquipeMemberRedirect() {
  const { email } = useParams<{ email: string }>();

  // Sans email exploitable, on retombe sur le roster plutot que sur un /profile/ vide.
  if (!email) return <Navigate to="/mon-equipe" replace />;

  return <Navigate to={`/profile/${encodeURIComponent(email)}?tab=gestion`} replace />;
}
